
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.4 13.8c-.3-.3-.4-.3-.7 0l-8.3 8.3c-.6.6-.2 3.7.7 2.7l3.9-3.9 3-3c.2-.2.8-.6 1-1l1 1 2.7 2.7 4.1 4.1c.9.9 1.3-2.1.7-2.7-2.7-2.7-5.4-5.4-8.1-8.2z"}}),_c('path',{attrs:{"d":"M20 4C11.3 4 5.7 11.1 5.1 19.1c-.1.3-.1.5-.1.8 0 .3 0 .5.1.7.7 8 6.2 15.2 14.9 15.2 8.6 0 15-7.5 15-15.9S28.6 4 20 4zM6.4 19.9C6.7 12.7 12.9 7.2 20 7.2c6.5 0 14.1 5.5 13.6 12.7-1 16.4-26.4 16.6-27.2 0z"}})])
          )
        }
      }
    